import { Highlights } from '@components/highlights/highlights';
import { PriceAndGuestsHighlights } from '@components/pricing/price-and-guests-highlights/PriceAndGuestsHighlights';
import { useIsVenue } from '@hooks/use-is-venue';
import { useLiteStorefront } from '@hooks/use-lite-storefront';
import React from 'react';
import { LiteDetailedPricingHighlights } from './components/lite-detailed-pricing-highlights';

export const AboutHighlights = () => {
	const isVenue = useIsVenue();
	const isLiteVendor = useLiteStorefront();

	if (!isLiteVendor) {
		return <Highlights />;
	}

	if (isVenue) {
		return <PriceAndGuestsHighlights />;
	}

	return <LiteDetailedPricingHighlights />;
};
